//      
export { PublicDraggable as default } from './draggable-api';



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/draggable/index.js